import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.regexp.to-string";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _inherits from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/wrapNativeSuper.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getDisplayMsg() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return code ? "".concat(msg, "(").concat(code, ")") : msg;
}

var RequestError = /*#__PURE__*/function (_Error) {
  _inherits(RequestError, _Error);

  var _super = _createSuper(RequestError);

  /**
   * 统一的请求错误封装
   * @param {string} msg
   * @param {number} code
   * @param {object} res
   */
  function RequestError() {
    var _this;

    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, RequestError);

    _this = _super.call(this, getDisplayMsg(msg, code));
    _this.msg = msg;
    _this.code = code;
    _this.res = res;
    _this.name = 'RequestError';
    return _this;
  }

  _createClass(RequestError, [{
    key: "toString",
    value: function toString() {
      return getDisplayMsg(this.msg, this.code);
    }
  }, {
    key: "toVerboseString",
    value: function toVerboseString() {
      return this.toString() + "(res:".concat(JSON.stringify(this.res), ")");
    }
  }]);

  return RequestError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RequestNetworkError = /*#__PURE__*/function (_RequestError) {
  _inherits(RequestNetworkError, _RequestError);

  var _super2 = _createSuper(RequestNetworkError);

  function RequestNetworkError() {
    var _this2;

    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '网络开小差了！请重试';
    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, RequestNetworkError);

    _this2 = _super2.call(this, msg, code, res);
    _this2.name = 'RequestNetworkError';
    return _this2;
  }

  return _createClass(RequestNetworkError);
}(RequestError);

var RequestSystemError = /*#__PURE__*/function (_RequestError2) {
  _inherits(RequestSystemError, _RequestError2);

  var _super3 = _createSuper(RequestSystemError);

  function RequestSystemError() {
    var _this3;

    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '系统貌似开小差了！请重试';
    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -2;
    var res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, RequestSystemError);

    _this3 = _super3.call(this, msg, code, res);
    _this3.name = 'RequestSystemError';
    return _this3;
  }

  return _createClass(RequestSystemError);
}(RequestError);

var RequestLoginError = /*#__PURE__*/function (_RequestError3) {
  _inherits(RequestLoginError, _RequestError3);

  var _super4 = _createSuper(RequestLoginError);

  function RequestLoginError() {
    var _this4;

    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '登录态失效，请先重新登录';
    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -11;
    var res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, RequestLoginError);

    _this4 = _super4.call(this, msg, code, res);
    _this4.name = 'RequestLoginError';
    return _this4;
  }

  return _createClass(RequestLoginError);
}(RequestError);

var RequestLogicError = /*#__PURE__*/function (_RequestError4) {
  _inherits(RequestLogicError, _RequestError4);

  var _super5 = _createSuper(RequestLogicError);

  function RequestLogicError() {
    var _this5;

    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '内部错误！请重试';
    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -3;
    var res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, RequestLogicError);

    _this5 = _super5.call(this, msg, code, res);
    _this5.name = 'RequestLogicError';
    return _this5;
  }

  return _createClass(RequestLogicError);
}(RequestError);

export { RequestNetworkError, RequestLoginError, RequestSystemError, RequestLogicError, RequestError };